import React, { useEffect, useState } from 'react'
import { Badge, Button, Card, Stack } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilSquare, faTrash } from '@fortawesome/free-solid-svg-icons';
import Helpers from '../Helpers';
import TimerActionButton from './TimerActionButton';
import UpdateModal from './UpdateModal';
import DeleteModal from './DeleteModal';

const ProjectCard = ({ project, onStartTimer, onStopTimer, onUpdateProject, onDelete }) => {

    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const handleUpdateModalClose = () => setShowUpdateModal(false);
    const handleUpdateModalShow = () => setShowUpdateModal(true);

    const handleDeleteModalClose = () => setShowDeleteModal(false);
    const handleDeleteModalShow = () => setShowDeleteModal(true);
  const [update, setUpdate] = useState(0);
  useEffect(() => {
      const interval = setInterval(() => {
         setUpdate(update+1) 
      },50);

      return (() => clearInterval(interval));
  }, [update]);
  return (
    // This is known as fragments in react which is used to return two things
    <>
        <UpdateModal 
            show={showUpdateModal} 
            handleClose={handleUpdateModalClose} 
            project={project} 
            onUpdateProject={onUpdateProject} 
        />

        <DeleteModal
            show={showDeleteModal}
            handleClose={handleDeleteModalClose}
            project={project}
            onDelete={onDelete}
        />
        <Card border="info">
        <Card.Header>
        <Stack direction="horizontal">
            <h4 className='me-auto'>{ project.name } </h4>
            <div className="vr" />
            <p className='my-auto ms-2'>{`$ ${project.price}`}</p>
        </Stack>
        </Card.Header>
        <Card.Body>
        <Card.Text>
            <p>{ project.description}</p>
            <h2 className='text-center'>{ Helpers.renderElapsedString(project.elapsed, project.runningSince) }</h2>
        </Card.Text>

        <Stack direction="horizontal" gap={3} className='mt-4'>
            <Badge pill bg={ project.status === 'Completed' ? 'success' : 'info'} size="md">{ project.status }</Badge>
            <Button variant="outline-danger" className='ms-auto' size="sm" onClick={handleDeleteModalShow}><FontAwesomeIcon icon={faTrash}/></Button>
            <Button 
                variant="outline-warning" 
                size="sm" 
                disabled={project.status === 'Completed'} 
                onClick={handleUpdateModalShow}
            >
                <FontAwesomeIcon icon={faPencilSquare}/>
            </Button>
        </Stack>
        <div className="d-grid mt-2">
            <TimerActionButton
                projectId={project.id}
                projectStatus={project.status}
                runningSince={project.runningSince}
                onStartTimer={onStartTimer}
                onStopTimer={onStopTimer}
            />
        </div>
        </Card.Body>
    </Card>
    </>
  )
}

export default ProjectCard